"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELASTIC_POSTS_PER_PAGE = exports.getThemedCoverages = exports.getMinuteBanner = exports.getLiveTransmission = exports.getSearchSections = exports.getPostDetails = exports.getRelatedPosts = exports.getTrending = exports.postSubscribe = exports.postPageView = exports.getMangoTracker = exports.getAssets = exports.getLoadMore = exports.postElasticSearch = exports.postSearch = exports.getPage = void 0;
const getPage_1 = __importDefault(require("./lib/get/getPage"));
exports.getPage = getPage_1.default;
const postSearch_1 = __importDefault(require("./lib/post/postSearch"));
exports.postSearch = postSearch_1.default;
const postElasticSearch_1 = __importDefault(require("./lib/post/postElasticSearch"));
exports.postElasticSearch = postElasticSearch_1.default;
const getLoadMore_1 = __importDefault(require("./lib/get/getLoadMore"));
exports.getLoadMore = getLoadMore_1.default;
const getAssets_1 = __importDefault(require("./lib/get/getAssets"));
exports.getAssets = getAssets_1.default;
const getMangoTracker_1 = __importDefault(require("./lib/get/getMangoTracker"));
exports.getMangoTracker = getMangoTracker_1.default;
const postPageView_1 = __importDefault(require("./lib/post/postPageView"));
exports.postPageView = postPageView_1.default;
const postSubscribe_1 = __importDefault(require("./lib/post/postSubscribe"));
exports.postSubscribe = postSubscribe_1.default;
const getTrending_1 = __importDefault(require("./lib/get/getTrending"));
exports.getTrending = getTrending_1.default;
const getRelatedPosts_1 = __importDefault(require("./lib/get/getRelatedPosts"));
exports.getRelatedPosts = getRelatedPosts_1.default;
const getPostDetails_1 = __importDefault(require("./lib/get/getPostDetails"));
exports.getPostDetails = getPostDetails_1.default;
const getSearchSections_1 = __importDefault(require("./lib/get/getSearchSections"));
exports.getSearchSections = getSearchSections_1.default;
const getLiveTransmission_1 = __importDefault(require("./lib/get/getLiveTransmission"));
exports.getLiveTransmission = getLiveTransmission_1.default;
const getMinuteBanner_1 = __importDefault(require("./lib/get/getMinuteBanner"));
exports.getMinuteBanner = getMinuteBanner_1.default;
const getThemedCoverages_1 = __importDefault(require("./lib/get/getThemedCoverages"));
exports.getThemedCoverages = getThemedCoverages_1.default;
var postElasticSearch_2 = require("./lib/post/postElasticSearch");
Object.defineProperty(exports, "ELASTIC_POSTS_PER_PAGE", { enumerable: true, get: function () { return postElasticSearch_2.ELASTIC_POSTS_PER_PAGE; } });
